import { render, staticRenderFns } from "./CryptoChart.vue?vue&type=template&id=3c709d1f&"
import script from "./CryptoChart.vue?vue&type=script&lang=js&"
export * from "./CryptoChart.vue?vue&type=script&lang=js&"
import style0 from "./CryptoChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports